import React, { useContext } from "react";
import * as tasks from "../extended/June2026Tasks";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import MaturaOriginalSourceLinks from "../../components/MaturaOriginalSourceLinks";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";

export const sheet = { id: "cke-r-2026-czerwiec", title: "Matura rozszerzona — czerwiec 2026",
  subtitle: "Formuła 2023 · 14 punktowanych części · 50 punktów", sourceLabel: "CKE · czerwiec 2026 · rozszerzenie",
  taskCount: 14, maxPoints: 50, sessionType: "additional" };
export const classification = tasks.classification;
export function generateTaskVariant(number, variant = "random", options = {}) {
  number = String(number);
  if (number.startsWith("13.") && !options.single) {
    const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
    const linkedTasks = ["13.1", "13.2"].map(n => generateTaskVariant(n, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === number), linkedTasks };
  }
  const task = tasks.generateTask(number, { ...options, variant });
  return { index: tasks.taskNumbers.indexOf(number), task: { ...task, displayBaseNumber: Number(number.split(".")[0]) },
    meta: { ...classification.find(row => row.taskNo === number), quizTypeKey: task.type, quizKind: "open", assessmentMode: "self" } };
}
export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return tasks.taskNumbers.map(number => generateTaskVariant(number, variant, { ...options, single: true, seed: `${seed}:${number.startsWith("13.") ? "axis-triangle" : number}` }));
}
export function generateTasks(variant, options) { return generatePagedTasks(variant, options).map(row => row.task); }
export const getVariantCounts = tasks.getVariantCounts;
function OriginalLink({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  return <MaturaPdfPreview url={tasks.pdfUrl("arkusz", task.taskNumber)} title={`Arkusz CKE · czerwiec 2026 · zadanie ${task.taskNumber}`} label="Zadanie w oryginalnym PDF · czerwiec 2026"/>;
}
export function renderTask(task) { return <>{tasks.renderTask(task)}<MaturaOriginalSourceLinks task={task}/><OriginalLink task={task}/></>; }
export const renderInput = tasks.renderInput;
export const checkAnswer = tasks.checkAnswer;
export const renderAnswer = tasks.renderAnswer;
export const renderExplanation = tasks.renderExplanation;
export const renderUserAnswer = tasks.renderUserAnswer;
export function getInteractionSupport() { return { renderInput: true, checkAnswer: true, renderUserAnswer: true }; }
